export default "__VITE_ASSET__DGnFtw9d__"